<template>
    <transition>
    <div class="container-fluid card-body">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Purchase</li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Vendor Performance</a></li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-header border-bottom bg-white">
                        <h4 class="card-title mb-0">Vendor Performance Analytics</h4>
                        <p class="text-muted mb-0">Monitor supplier ratings based on delivery times and quality.</p>
                    </div>
                    <div class="card-body">
                        <table class="table table-bordered table-centered table-nowarp w-100" v-if="!loading">
                            <thead class="table-light">
                                <tr class="border success item-head">
                                    <th class="text-center" width="5%">SL </th>
                                    <th class="text-center" width="25%">Vendor Name</th>
                                    <th class="text-center" width="20%">Purchase Order Ref</th>
                                    <th class="text-center" width="15%">Delivery Time (Days)</th>
                                    <th class="text-center" width="15%">Quality Rating</th>
                                    <th class="text-center" width="20%">Overall Rating</th>
                                </tr>
                            </thead>
                            <tbody v-if="items.length > 0">
                                <tr class="border" v-for="(item, index) in items" :key="index">
                                    <td class="text-center">{{ index + 1 }} </td>
                                    <td class="text-center">{{ item.supplier ? item.supplier.name : 'Unknown Vendor' }} </td> 
                                    <td class="text-center">{{ item.purchase_order ? item.purchase_order.reference_no : 'N/A' }} </td> 
                                    <td class="text-center">
                                        <span :class="{'text-danger': item.delivery_time_days > 7, 'text-success': item.delivery_time_days <= 3}">
                                            {{ item.delivery_time_days }}
                                        </span>
                                    </td> 
                                    <td class="text-center">
                                        <div class="text-warning">
                                            <i class="fas fa-star" v-for="n in item.quality_rating" :key="'q_full_'+n"></i>
                                            <i class="far fa-star" v-for="n in (5 - item.quality_rating)" :key="'q_empty_'+n"></i>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="text-warning">
                                            <i class="fas fa-star" v-for="n in item.overall_rating" :key="'o_full_'+n"></i>
                                            <i class="far fa-star" v-for="n in (5 - item.overall_rating)" :key="'o_empty_'+n"></i>
                                        </div>
                                        <small>({{ item.overall_rating }} / 5)</small>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="6" class="text-center text-muted">No vendor performance data found.</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5"></div>
                                <div class=" col-md-2"> 
                                    <div class="spinner"></div>
                                </div>
                                <div class="col-md-5"></div>
                            </div>
                        </div>

                    </div> 
                </div>
            </div>
        </div>
    </div>
    </transition>
</template>

<script> 
import axios from 'axios';  
export default {
    name: 'VendorPerformance',
    data() {
        return {
            loading: true,
            items: [],
        };
    },
    created() {
        this.fetchVendorPerformanceData();
    },
    methods: { 
        fetchVendorPerformanceData() { 
            axios.get(this.apiUrl+'/vendor_performances', this.headerjson)
            .then((res) => {
                this.items = res.data.data;
            }).finally(( ) => {
                this.loading = false;
            });
        },
    },
    mounted() {
        window.scrollTo(0, 0);
    }
}
</script>

<style scoped>
.spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(0, 0, 0, 0.05);
    border-top-color: #000;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
